import { Practice, Gender } from '@aldebaran/prisma';

type PracticeParams = Pick<Practice, 'name' | 'practiceNameGender'>;

/**
 * Gets the French article with preposition for practice name based on gender
 * @param gender - Practice name gender (MALE or FEMALE), or null/undefined
 * @returns The appropriate French article with preposition ("au" for MALE, "à la" for FEMALE)
 *
 * Examples:
 * - MALE: "au"
 * - FEMALE: "à la"
 */
export const getPracticeArticle = (gender?: Gender | null): string => {
  return gender === 'FEMALE' ? 'à la' : 'au';
};

/**
 * Formats a welcome message with the practice name
 * @param practice - Practice object with name and optional gender
 * @returns A formatted welcome message
 *
 * Examples:
 * - "Bienvenue au Cabinet Médical"
 * - "Bienvenue à la MSP Aldebaran"
 */
export const formatPracticeWelcome = (practice: PracticeParams): string => {
  const article = getPracticeArticle(practice.practiceNameGender);
  return `Bienvenue ${article} ${practice.name}`;
};
